import z from "zod";

export const controlSchema = z.object({
  active: z.boolean(),
  created_at: z.date(),
  updated_at: z.date(),
});

export type Control = z.infer<typeof controlSchema>;
